<template>
  <div :class="{'animationComplete' : animationComplete}">
    <BackgroundFader class="blurable" ref="bgFader" :content="images" @complete="animationComplete = true;"/>
    <PageWrapper class="blurable">

      <InfoBlock :subTitle="gd[currentScenario].subTitle" :title="gd[currentScenario].title" :content="gd[currentScenario].steps[currentStep]"/>

      <Button btnContent="Replay animation" iconType="replay" @click="replay" class="replayButton reveal" />
      
      <Button class="scenarioNextButton" btnContent="Next step" iconType="arrow" @click="$router.push('step2')"/>
      <Button class="scenarioPreviousButton" iconType="arrow" @click="$router.push('intro')"/>
      <Button btnContent="Gallery" @click="openGallery" class="galleryButton" />
    
    </PageWrapper>

    <GalleryModal ref="galleryModal" :content="galleryImages"/>
  </div>
</template>


<script>
import PageWrapper from '@/components/PageWrapper';
import InfoBlock from '@/components/InfoBlock';
import AutoStep from '@/components/AutoStep';
import Button from '@/components/Button';
import ModelWindow from "@/components/ModelWindow";
import HotspotsWrapper from '@/components/HotspotsWrapper';
import Hotspot from '@/components/Hotspot';
import BackgroundFader from "@/components/BackgroundFader";
import gd from "@/assets/stores/globalDS.js";
import GalleryModal from '@/components/paul/GalleryModal';

export default {
  components: {
    PageWrapper,
    InfoBlock,
    AutoStep,
    Button,
    ModelWindow,
    HotspotsWrapper,
    Hotspot,
    BackgroundFader,
    GalleryModal
  },
  data() {
    return {
      gd: gd,
      animationComplete: false,
      images: [
        'biological/1-1.jpg',
        'biological/1-2.jpg',
        'biological/1-3.jpg',
        'biological/1-4.jpg',
        'biological/1-5.jpg'
      ],
      galleryImages: gd.gallery.biological
    }
  },
  computed: {
    appPath() {
      return this.$router.currentRoute.fullPath.split("/");
    },
    currentStep() {
      return this.appPath[this.appPath.length - 1];
    },
    currentScenario() {
      return this.appPath[this.appPath.length - 2];
    }
  },
  methods: {
    replay() {
      this.animationComplete = false;
      this.$refs.bgFader.reset();
    },
    openModel: function(modelWindow) {
      this.$refs[modelWindow].openModel();
    },
    openGallery: function() {
      this.$refs.galleryModal.openModal();
    }
  }
}
</script>

